import './App.css';
import EmailPage from './components/EmailPage/EmailPage';

function App() {
  return (
    <div className="App">
      <EmailPage/>
    </div>
  );
}

export default App;
